
<template>
  <!-- 学校名称 -->
  <div>
    <el-dialog title="学校名称" :visible.sync="dialogTableVisible" append-to-body>
      <div class="query-form">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="80px"
        >
          <el-row :gutter="24">
            <el-col :span="8" >
              <el-form-item
                label="学校名称"
                prop="xxmc"
              >
                <el-input
                  v-model="form.xxmc"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item
                label="院校类别"
                prop="yxlb"
              >
                <el-select v-model="form.yxlb" placeholder="请选择" style="width: 100%" :clearable="true">
                    <el-option v-for="item in options.yxlb" :key="item.value" :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            style="display: flex; justify-content: flex-end; align-items: center"
          >
            <el-col :span="2" :offset="18">
              <el-button type="primary" size="small" @click="getInfo">查询</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="info" size="small" @click="clear">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table height="350" border :data="gridData"
        @sort-change="handleSortChange"
        :header-cell-class-name="handleHeadAddClass"
      >
        <el-table-column
          property="xxbsm"
          label="学校标识码"
        ></el-table-column>
        <el-table-column
          property="xxmc"
          label="学校名称"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          property="yxlbmc"
          label="院校类别"
          sortable="custom"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="choice(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <pagination :total="pagination.total" 
          @currentPageChange="currentPageChange" 
          @pageSizeChange="pageSizeChange"
          :pageSizes="pageSizes">
        </pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import share from "@/assets/sharejs/share.js";
import request from "@/api/postList.js";
import pagination from "@/components/pagination.vue";

let cols = [];
export default {
  props: ['zplb'],
  components: {
    pagination
  },
  data() {
    return {
      gridData: [],
      sortField: {},
      orderBys: [], //存储排序信息
      form: {
        xxmc: "",
        yxlb: "",
      },
      dialogTableVisible: false,
      pagination: {
        total: 0,
        pageSize: 10,
        page: 1,
      },
      pageSizes: [10, 30, 50, 100],
      options: {
        yxlb: share.get("lb"),
      },
    };
  },
  watch: {
    dialogTableVisible() {
      if(this.dialogTableVisible){
        this.getInfo()
      }
    },
  },
  methods: {
    open(data) {
      console.log('queryType>>>', data);
      this.form.xxmc = data.xxmc;
      this.queryType = data.queryType;
      this.dialogTableVisible = true;
    },
    close() {
      this.dialogTableVisible = false;
    },
    //排序方法
    async handleSortChange({ order, prop }) {
      this.orderPage = order;
      this.propPage = prop;
      // 触发的排序和缓存的排序相同时，取消该字段的排序
      if (!order || this.sortField[prop] === order) {
          this.sortField[prop] = null;
      } else {
          this.sortField[prop] = order;
      }
      console.log("对象存储数据>>>>>", this.sortField);

      this.orderBys = [];

      let direction = "";
      for (var i in this.sortField) {
          if (this.sortField[i] == "ascending") {
              direction = "ASC";
          } else if (this.sortField[i] == "descending") {
              direction = "DESC";
          } else {
              direction = "";
          }

          if (i == "yxlbmc") {
            i = "yxlb";
          }

          this.orderBys.push({
              column: i,
              direction: direction,
          });
      }

      this.getInfo();
    },

    handleHeadAddClass({ column }) {
        cols.push(column); //重置使用数组
        if (this.sortField[column.property]) {
            column.order = this.sortField[column.property];
        }
    },
    clear(){
      this.form.xxmc = "";
      this.form.yxlb = "";

      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.pagination.total = 0;
      this.gridData = [];
      this.sortField = {};
      this.orderBys = [];
      cols.forEach((col) => {
          col.order = "";
      });
    },
    pageSizeChange(e) {
      this.pagination.pageSize = e;
      this.pagination.page = 1;
      this.getInfo();
    },
    currentPageChange(e) {
      this.pagination.page = e;
      this.getInfo();
    },
    /* 获取信息 */
    async getInfo() {
      var orderInfo = JSON.stringify(this.orderBys);
      const para = {
        xxmc: this.form.xxmc,
        yxlb: this.form.yxlb,
        zplb: this.zplb,
        page: this.pagination.page, //页码
        pageSize: this.pagination.pageSize, //每页显示的条数
        orderInfo: orderInfo,
      };
      const data = await request.queryUniversities(para);
      this.gridData = data.vds.map((item)=>{
        return {
            ...item,
            yxlbmc: share.getValue('lb', item.yxlb),
        }

      });
      this.pagination.total = data.total;
    },
    /* 选择 */
    choice(data) {
      const param = {
        ...data,
        queryType: this.queryType
      }
      this.$emit("choiceData", param);
      this.dialogTableVisible = false;
    },
  },
};
</script>

<style>
.query-form {
  transition: display 0.5s;
}
</style>